import {
  GuardianEmail,
  GuardianFirstName,
  GuardianLastName,
} from "@up/application-fields";

import type { ReactNode } from "react";

export function GuardianInformationPage({
  bottom,
}: {
  bottom: () => ReactNode;
}) {
  return (
    <>
      <div className="grid-cols-2 gap-4 md:grid">
        <GuardianFirstName />

        <GuardianLastName />
      </div>

      <GuardianEmail />

      {bottom()}
    </>
  );
}

// GuardianInformation.beforeRender = function ({ router, userData, direction }) {
//   const query = router.query || {}

//   if (userData['student-age'] === '18') {
//     query.page = direction === -1 ? 2 : 4
//   } else {
//     query.page = direction === -1 ? 2 : 3
//   }

//   router.push({
//     query,
//   })
// }
